import gql from 'graphql-tag';

export default gql`
  mutation requestChanges($suggestionsListId: ID!, $message: String!) {
    requestChangesForSuggestionsList(
      suggestionsListId: $suggestionsListId
      message: $message
    )
  }
`;
